import type { OverviewItem } from '@/shared/types/overview';
import type { LessonBlock } from '@/shared/types/lesson';

export const newOverviewTextItem = (init?: {
  categoryName?: string;
  html?: string;
}): OverviewItem => ({
  id: crypto.randomUUID(),
  type: 'text',
  categoryName: init?.categoryName ?? 'New Overview Section',
  html: init?.html ?? '<p>Add your content here...</p>',
});

export const newOverviewStandardsItem = (init?: { categoryName?: string }): OverviewItem => ({
  id: crypto.randomUUID(),
  type: 'standards',
  categoryName: init?.categoryName ?? 'Standards',
  standards: [],
});

export const newLessonBlock = (lesson_order: number): LessonBlock => ({
  id: crypto.randomUUID(),
  lesson_order,
  html: '',
});

export type OverviewOwnerType = 'course' | 'unit' | 'lesson';

// Default overview scaffold seeded into newly created courses/units/lessons.
// Behind a single accessor so a future per-level/per-template source can replace
// the body without changing call sites. `_ownerType` is reserved for that future
// per-level customization (the same set is used for every level today).
export const getDefaultOverviewItems = (_ownerType: OverviewOwnerType): OverviewItem[] => [
  newOverviewTextItem({ categoryName: 'Overview', html: '' }),
  newOverviewStandardsItem({ categoryName: 'Standards' }),
  newOverviewTextItem({ categoryName: 'Essential Questions', html: '' }),
];
